import { faHome } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Table, Typography } from "antd"
import { NavigationService } from "../../services/navigationService"
import { CustomerDetail, CustomerPropertyRow } from "./customerApi"
import { useCustomerPropertiesQuery } from "./customerQueries"

const { Text } = Typography

type Props = {
  customer: CustomerDetail
  navigationService: NavigationService
}

const CustomerPropertiesTab = ({ customer, navigationService }: Props) => {
  const propertiesQuery = useCustomerPropertiesQuery(customer.id)

  return <section>
    <Text strong><FontAwesomeIcon icon={faHome} /> Customer Properties</Text>
    <Table<CustomerPropertyRow>
      rowKey="id"
      dataSource={propertiesQuery.data ?? []}
      loading={propertiesQuery.isLoading}
      pagination={false}
      size="small"
      style={{ marginTop: 12 }}
      columns={[
        { title: 'Property Name', dataIndex: 'address', key: 'name' },
        { title: 'Nickname', dataIndex: 'nickname', key: 'nickname' },
        { title: 'Address', key: 'address', render: (_, p) => `${p.address} ${p.cityStateZip}`.trim() },
        { title: 'Status', key: 'status', render: (_, p) => (p.isActive ? 'Active' : 'Inactive') },
        { title: 'Created On', key: 'createdOn', render: () => null },
      ]}
    />
    <div style={{ marginTop: 16 }}>
      <Button
        type="primary"
        icon={<FontAwesomeIcon icon={faHome} />}
        onClick={() => navigationService.setUrl(`customers/${customer.url}/properties`)}
      >
        Add or Update Properties
      </Button>
    </div>
  </section>
}

export default CustomerPropertiesTab
